import { render, staticRenderFns } from "./TwoColTableComponent.vue?vue&type=template&id=c94d0716"
import script from "./TwoColTableComponent.vue?vue&type=script&lang=js"
export * from "./TwoColTableComponent.vue?vue&type=script&lang=js"
import style0 from "./TwoColTableComponent.vue?vue&type=style&index=0&id=c94d0716&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports